import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { api } from "@/lib/api";

export const AdminStatusBadge = () => {
  const { pathname } = useLocation();
  const [user, setUser] = useState(null);
  const isAdminArea = pathname.startsWith("/tigasatu");
  useEffect(() => {
    if (isAdminArea) return undefined;
    let alive = true;
    api.get("/auth/me").then((r) => { if (alive) setUser(r.data?.role === "admin" ? r.data : null); }).catch(() => { if (alive) setUser(null); });
    return () => { alive = false; };
  }, [isAdminArea]);
  if (isAdminArea || !user) return null;
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    window.location.reload();
  };
  const bottom = pathname === "/brewek" ? "bottom-28" : "bottom-4";
  return (
    <div data-testid="admin-status-badge" className={`fixed left-4 ${bottom} z-[90] flex items-center gap-1 rounded-full border border-volt/40 bg-ink/90 py-1.5 pl-3 pr-1.5 text-xs text-paper shadow-lg backdrop-blur-md`}>
      <ShieldCheck className="h-4 w-4 text-volt" />
      <a href="/tigasatu/dashboard" data-testid="admin-status-dashboard" className="px-1.5 font-medium hover:text-volt">Admin login</a>
      <button onClick={logout} data-testid="admin-status-logout" className="flex items-center gap-1 rounded-full bg-white/10 px-2.5 py-1 hover:bg-white/20"><LogOut className="h-3.5 w-3.5" /> Logout</button>
    </div>
  );
};
